import React from "react"

import { useStaticQuery, graphql, Link } from "gatsby"
import Img from "gatsby-image"

import { Container } from "react-bootstrap"

const Footer = () => {
  const data = useStaticQuery(QUERY)
  const { FFFLogo, SLVLogo, CVLogo } = data

  return (
    <footer className="section__footer section__bg-darkgray" id="contact">
      <Container className="footer__inner-wrap">
        <div className="fff-logo">
          <Img fluid={FFFLogo.childImageSharp.fluid} alt="FFF Logo" />
        </div>

        <h2>Contact</h2>

        <div className="d-flex flex-column flex-lg-row justify-content-between footer__contact-details">
          <div className="contact__address contact-details__col">
            <div className="contact__heading">Address</div>
            <p>
              328 Swanston Street Melbourne
              <br /> 3000 Australia
            </p>
          </div>
          <div className="contact__phone contact-details__col">
            <div className="contact__heading">Phone</div>
            <a href="tel:0386647111">
              <p>03 8664 7111</p>
            </a>
          </div>

          <div className="contact__email contact-details__col">
            <div className="contact__heading">Email</div>
            <p>
              <a href="mailto:startspace@slv.vic.gov.au">
                startspace@slv.vic.gov.au
              </a>
            </p>
          </div>

          <div className="contact__social contact-details__col">
            <div className="contact__heading">Follow Us</div>
            <div className="d-flex justify-content-between socials">
              <Link
                to="https://www.youtube.com/channel/UCovxORj-HKHcwmcAoCrkxVw"
                className="icon__youtube icon"
              ></Link>
              <Link
                to="https://www.linkedin.com/company/startspacehq/"
                className="icon__ln icon"
              ></Link>
              <Link
                to="https://instagr.am/StartSpaceHQ"
                className="icon__insta icon"
              ></Link>
              <Link
                to="https://twitter.com/StartSpaceHQ"
                className="icon__twitter icon"
              ></Link>
              {/*}<Link to="#" className="icon__fb icon"></Link>*/}
            </div>
          </div>
        </div>

        <div className="footer__credit">
          <p>
            Future Founders {new Date().getFullYear()} photography by{" "}
            <Link
              to="//www.carmenzammit.com/"
            >
              Carmen Zammit
            </Link>
            , <Link to="http://danielmahon.com/">Daniel Mahon</Link>,{" "}
            <Link
              to="//happy-moment.org/"
            >
              Linh Pham
            </Link>{" "}
            and{" "}
            <Link
              to="//www.rachaelcoleyphotography.com/"
            >
              Rachael Coley
            </Link>{" "}
          </p>
        </div>

        <div className="footer__acknowledgement">
          <p>
            State Library Victoria acknowledges the traditional lands of all the
            Victorian Aboriginal Clans, and their cultural practices and
            knowledge systems. We recognise that our collections hold
            traditional cultural knowledge belonging to Indigenous communities
            in Victoria and around the country. We support communities to
            protect the integrity of this information, gathered from their
            Ancestors in the colonial period. We pay our respects to their
            Elders, past and present, who have handed down these systems of
            practice to each new generation for millennia.
          </p>
        </div>

        <div className="footer__logos d-flex flex-column flex-md-row justify-content-between align-items-center">
          <div className="logo__slv logo">
            <a href="https://slv.vic.gov.au">
              <Img fixed={SLVLogo.childImageSharp.fixed} alt="" />
            </a>
          </div>
          <div className="logo__creative-vic logo">
            <a href="https://creative.vic.gov.au/">
              <Img fixed={CVLogo.childImageSharp.fixed} alt="" />
            </a>
          </div>
        </div>

        <div className="footer__tc d-flex flex-column flex-lg-row justify-content-between">
          <Link to="https://www.slv.vic.gov.au/privacy">Privacy Policy</Link>

          <Link to="https://www.slv.vic.gov.au/disclaimer">
            Terms &amp; Conditions
          </Link>

          <Link to="https://www.slv.vic.gov.au/interact-with-us/media-centre">
            Press release
          </Link>
        </div>
      </Container>
    </footer>
  )
}
export default Footer

const QUERY = graphql`
  query {
    SLVLogo: file(relativePath: { eq: "logos/SLV-logo-white.png" }) {
      childImageSharp {
        fixed(width: 250) {
          ...GatsbyImageSharpFixed
        }
      }
    }
    CVLogo: file(relativePath: { eq: "logos/CV-logo-white.png" }) {
      childImageSharp {
        fixed(width: 250) {
          ...GatsbyImageSharpFixed
        }
      }
    }
    FFFLogo: file(relativePath: { eq: "logo-light2x.png" }) {
      childImageSharp {
        fluid(maxWidth: 500) {
          ...GatsbyImageSharpFluid
        }
      }
    }
  }
`
